module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/bookingType.svg?574ec04b";